export const ExploreFilledIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="82"
      height="76"
      viewBox="0 0 82 76"
      fill="none"
    >
      <path
        d="M77.0501 0.998642L45.7969 24.1238L51.6087 10.4954L77.0501 0.998642Z"
        fill="#E17726"
        stroke="#E17726"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.95557 0.998642L35.9305 24.3396L30.3971 10.4954L4.95557 0.998642Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.7931 54.6179L57.4775 67.3213L75.2834 72.2239L80.3842 54.8956L65.7931 54.6179Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.64795 54.8956L6.71766 72.2239L24.4927 67.3213L16.208 54.6179L1.64795 54.8956Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5334 33.1569L18.5874 40.6187L36.2078 41.4204L35.6205 22.4578L23.5334 33.1569Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M58.471 33.1594L46.1988 22.2444L45.7969 41.4228L63.4172 40.6212L58.471 33.1594Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.498 67.3205L35.1629 62.1714L25.9819 55.018L24.498 67.3205Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.8413 62.1714L57.4753 67.3205L56.0223 55.018L46.8413 62.1714Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.4753 67.3201L46.8413 62.1711L47.7068 69.0777L47.6139 72.0069L57.4753 67.3201Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.498 67.3201L34.3903 72.0069L34.3284 69.0777L35.1629 62.1711L24.498 67.3201Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.5702 50.4567L25.729 47.8668L31.9734 44.9992L34.5702 50.4567Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.4321 50.4567L50.0289 44.9992L56.3043 47.8668L47.4321 50.4567Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.4902 67.3213L26.0359 54.6179L16.2056 54.8956L24.4902 67.3213Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.9604 54.6179L57.4753 67.3213L65.7908 54.8956L55.9604 54.6179Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M63.4172 40.6205L45.7969 41.4221L47.4352 50.4566L50.032 44.9988L56.3073 47.8664L63.4172 40.6205Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7283 47.8664L31.9727 44.9988L34.5695 50.4566L36.2078 41.4221L18.5874 40.6205L25.7283 47.8664Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.5947 40.6205L25.983 55.0198L25.7355 47.8664L18.5947 40.6205Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.2997 47.8664L56.0215 55.0198L63.4097 40.6205L56.2997 47.8664Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.2123 41.4208L34.5737 50.4552L36.6449 61.1234L37.1087 47.0634L36.2123 41.4208Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.7939 41.4208L44.9282 47.0327L45.3611 61.1234L47.4322 50.4552L45.7939 41.4208Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.4339 50.4551L45.3628 61.1233L46.8467 62.1718L56.0279 55.0184L56.3061 47.865L47.4339 50.4551Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.729 47.865L25.9765 55.0184L35.1575 62.1718L36.6414 61.1233L34.5702 50.4551L25.729 47.865Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.621 72.0101L47.7136 69.0809L46.91 68.4025H35.1013L34.3284 69.0809L34.3903 72.0101L24.498 67.3234L27.9603 70.16L34.9776 75.001H47.0026L54.0508 70.16L57.4821 67.3234L47.621 72.0101Z"
        fill="#C0AC9D"
        stroke="#C0AC9D"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M46.8459 62.1713L45.362 61.1231H36.6446L35.1609 62.1713L34.3262 69.0781L35.099 68.3997H46.9078L47.7116 69.0781L46.8459 62.1713Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.3724 25.6345L81.0002 12.8695L77.0432 0.998642L46.8413 23.353L58.4644 33.158L74.8793 37.9373L78.4962 33.7131L76.9197 32.5721L79.4235 30.2906L77.507 28.8105L80.011 26.8988L78.3724 25.6345Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 12.8695L3.65852 25.6345L1.95831 26.8988L4.49317 28.8105L2.57657 30.2906L5.08052 32.5721L3.50395 33.7131L7.12078 37.9373L23.5357 33.158L35.1588 23.353L4.95687 0.998642L1 12.8695Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.8784 37.9378L58.4636 33.1588L63.4097 40.6205L56.0215 55.0196L65.79 54.8964H80.3809L74.8784 37.9378Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.5343 33.1588L7.11955 37.9378L1.64795 54.8964H16.208L25.9764 55.0196L18.5883 40.6205L23.5343 33.1588Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.7956 41.4214L46.8466 23.3528L51.6071 10.4954H30.4009L35.1614 23.3528L36.2124 41.4214L36.6143 47.0947L36.6453 61.1241H45.3627L45.3937 47.0947L45.7956 41.4214Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MetamaskIconSmall = ({
  width = 22,
  height = 20,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22 20"
      fill="none"
    >
      <path
        d="M20.0125 1L12.1992 6.62483L13.6522 3.30993L20.0125 1Z"
        fill="#E17726"
        stroke="#E17726"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.98889 1L9.73262 6.67732L8.34927 3.30993L1.98889 1Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.1983 14.042L15.1194 17.1319L19.5709 18.3244L20.8461 14.1095L17.1983 14.042Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.16199 14.1095L2.42942 18.3244L6.87319 17.1319L4.80199 14.042L1.16199 14.1095Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.63335 8.82213L5.39685 10.6371L9.80195 10.8321L9.65514 6.21973L6.63335 8.82213Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.3678 8.82239L12.2997 6.16748L12.1992 10.8323L16.6043 10.6373L15.3678 8.82239Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.87451 17.1315L9.54073 15.8791L7.24548 14.1392L6.87451 17.1315Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4603 15.8791L15.1188 17.1315L14.7556 14.1392L12.4603 15.8791Z"
        fill="#E27625"
        stroke="#E27625"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.1188 17.1318L12.4603 15.8794L12.6767 17.5593L12.6535 18.2718L15.1188 17.1318Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.87451 17.1318L9.34757 18.2718L9.33211 17.5593L9.54073 15.8794L6.87451 17.1318Z"
        fill="#D5BFB2"
        stroke="#D5BFB2"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.39255 13.0301L7.18225 12.4001L8.74335 11.7026L9.39255 13.0301Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.608 13.0301L13.2572 11.7026L14.8261 12.4001L12.608 13.0301Z"
        fill="#233447"
        stroke="#233447"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.87255 17.1319L7.25899 14.042L4.80139 14.1095L6.87255 17.1319Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.7401 14.042L15.1188 17.1319L17.1977 14.1095L14.7401 14.042Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6043 10.6372L12.1992 10.8322L12.6088 13.0297L13.258 11.7022L14.8268 12.3997L16.6043 10.6372Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.18207 12.3997L8.74318 11.7022L9.39237 13.0297L9.80195 10.8322L5.39685 10.6372L7.18207 12.3997Z"
        fill="#CC6228"
        stroke="#CC6228"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.39868 10.6372L7.24575 14.1396L7.18388 12.3997L5.39868 10.6372Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.8249 12.3997L14.7554 14.1396L16.6024 10.6372L14.8249 12.3997Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.80307 10.832L9.39343 13.0295L9.91122 15.6244L10.0272 12.2045L9.80307 10.832Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1985 10.832L11.9821 12.197L12.0903 15.6244L12.6081 13.0295L12.1985 10.832Z"
        fill="#E27525"
        stroke="#E27525"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6085 13.0294L12.0907 15.6243L12.4617 15.8793L14.757 14.1394L14.8265 12.3994L12.6085 13.0294Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.18225 12.3994L7.24412 14.1394L9.53937 15.8793L9.91034 15.6243L9.39255 13.0294L7.18225 12.3994Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6553 18.2723L12.6784 17.5598L12.4775 17.3948H9.52533L9.33211 17.5598L9.34757 18.2723L6.87451 17.1323L7.74007 17.8223L9.49439 18.9998H12.5006L14.2627 17.8223L15.1205 17.1323L12.6553 18.2723Z"
        fill="#C0AC9D"
        stroke="#C0AC9D"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.4615 15.8795L12.0905 15.6245H9.91114L9.54023 15.8795L9.33154 17.5595L9.52476 17.3944H12.4769L12.6779 17.5595L12.4615 15.8795Z"
        fill="#161616"
        stroke="#161616"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.3431 6.9923L21 3.88741L20.0108 1L12.4603 6.43736L15.3661 8.82225L19.4698 9.98474L20.374 8.95728L19.9799 8.67975L20.6059 8.12481L20.1267 7.7648L20.7527 7.29981L20.3431 6.9923Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1 3.88741L1.66463 6.9923L1.23958 7.29981L1.87329 7.7648L1.39414 8.12481L2.02013 8.67975L1.62599 8.95728L2.5302 9.98474L6.63393 8.82225L9.53971 6.43736L1.98922 1L1 3.88741Z"
        fill="#763E1A"
        stroke="#763E1A"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.4696 9.9847L15.3659 8.82227L16.6024 10.6372L14.7554 14.1396L17.1975 14.1096H20.8452L19.4696 9.9847Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.63357 8.82227L2.52989 9.9847L1.16199 14.1096H4.802L7.2441 14.1396L5.39707 10.6372L6.63357 8.82227Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.1989 10.8323L12.4617 6.43744L13.6518 3.31006H8.35022L9.54035 6.43744L9.80311 10.8323L9.90359 12.2123L9.91132 15.6247H12.0907L12.0984 12.2123L12.1989 10.8323Z"
        fill="#F5841F"
        stroke="#F5841F"
        strokeWidth="0.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const OwalletIcon = ({
  width = 32,
}: {
  width?: number;
  height?: number;
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={width}
      viewBox="0 0 32 31"
      fill="none"
    >
      <path
        opacity="0.51"
        d="M28.0191 10.3829H18.2261C17.7469 10.3829 17.3496 9.9938 17.3496 9.5064V5.31644C17.3496 4.83723 17.7387 4.43994 18.2261 4.43994H28.4573C28.7031 4.43994 28.8956 4.63244 28.8956 4.87819V9.51459C28.8874 9.9938 28.4983 10.3829 28.0191 10.3829Z"
        fill="#AD83FF"
      />
      <path
        opacity="0.5"
        d="M25.5699 8.35573H16.5183C16.2479 8.35573 16.0391 8.13456 16.0391 7.87652V2.89607C16.0391 2.62575 16.2602 2.41687 16.5183 2.41687H25.5781C25.8484 2.41687 26.0573 2.63804 26.0573 2.89607V7.87652C26.0614 8.14684 25.8402 8.35573 25.5699 8.35573Z"
        fill="#AD83FF"
      />
      <path
        opacity="0.9"
        d="M31.5382 12.6567H20.9179C20.664 12.6567 20.4551 12.456 20.4551 12.1939V7.04143C20.4551 6.7875 20.6558 6.57861 20.9179 6.57861H31.5382C31.7922 6.57861 32.001 6.77931 32.001 7.04143V12.1898C32.0051 12.4437 31.7922 12.6567 31.5382 12.6567Z"
        fill="#AD83FF"
      />
      <path
        d="M28.056 24.3864C25.2545 28.3224 20.6549 30.8905 15.4574 30.8905C6.92184 30.8905 0 23.9686 0 15.4331C0 7.27021 6.33205 0.58183 14.3516 0.0166143C14.4171 0.0166143 14.4785 0.00842285 14.5441 0.00842285C15.0519 0.0248059 15.4574 0.405712 15.4574 0.876724V6.45106C10.4892 6.45106 6.46721 10.4772 6.46721 15.4413C6.46721 20.4053 10.4933 24.4315 15.4574 24.4315C20.4215 24.4315 24.4476 20.4053 24.4476 15.4413C24.4476 15.4413 29.4731 17.5178 28.056 24.3864Z"
        fill="#925AFF"
      />
      <path
        d="M30.8745 16.6249C30.7967 15.9573 30.1987 15.4412 29.4656 15.4412H16.5025C15.9291 15.4412 15.4622 14.9784 15.4622 14.4009V0.876676C15.4622 0.405663 15.0567 0.0247573 14.5488 0.00837422C14.6062 0.00837422 14.6676 0.000182195 14.7249 0.000182195C15.3844 -0.00800933 15.7366 0.262311 15.8308 0.348322L15.839 0.356514L15.8554 0.372897L29.7769 14.2944C30.9565 15.4822 30.8745 16.6249 30.8745 16.6249Z"
        fill="#AD83FF"
      />
      <path
        opacity="0.91"
        d="M30.8653 16.6128C30.8571 16.7848 30.8408 16.9527 30.8244 17.1125C30.5336 19.8034 29.5506 22.2895 28.0556 24.3866C29.4728 17.5139 24.4473 15.4414 24.4473 15.4414H29.4605C30.1977 15.4414 30.7957 15.9575 30.8653 16.6128Z"
        fill="url(#paint0_linear_3133_17288)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_3133_17288"
          x1="27.6563"
          y1="24.7394"
          x2="27.6563"
          y2="15.4805"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="8.52446e-08" stopColor="#925AFF" />
          <stop offset="1" stopColor="#713BBB" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const PhantomIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="28"
      viewBox="0 0 32 28"
      fill="none"
    >
      <g clipPath="url(#clip0_3450_24166)">
        <path
          d="M3.78035 27.3018C7.85721 27.3018 10.921 23.7563 12.7494 20.9546C12.5271 21.5745 12.4035 22.1943 12.4035 22.7893C12.4035 24.4258 13.3424 25.591 15.1955 25.591C17.7405 25.591 20.4584 23.3596 21.8667 20.9546C21.7679 21.3017 21.7185 21.6241 21.7185 21.9216C21.7185 23.0621 22.3609 23.7811 23.6704 23.7811C27.7967 23.7811 31.9477 16.4669 31.9477 10.0702C31.9477 5.08661 29.4274 0.69812 23.1022 0.69812C11.9835 0.69812 0 14.2851 0 23.0621C0 26.5084 1.85311 27.3018 3.78035 27.3018ZM19.2724 9.52472C19.2724 8.28503 19.9642 7.41726 20.9772 7.41726C21.9655 7.41726 22.6574 8.28503 22.6574 9.52472C22.6574 10.7644 21.9655 11.657 20.9772 11.657C19.9642 11.657 19.2724 10.7644 19.2724 9.52472ZM24.5599 9.52472C24.5599 8.28503 25.2518 7.41726 26.2648 7.41726C27.2531 7.41726 27.945 8.28503 27.945 9.52472C27.945 10.7644 27.2531 11.657 26.2648 11.657C25.2518 11.657 24.5599 10.7644 24.5599 9.52472Z"
          fill="#AB9FF2"
        />
      </g>
      <defs>
        <clipPath id="clip0_3450_24166">
          <rect
            width="32"
            height="26.6037"
            fill="white"
            transform="translate(0 0.69812)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
